import React from 'react';

import PropTypes from 'prop-types';

import './absasset.scss';

const AbsoluteAsset = props => (
  <div className={`absolute-asset ${props.className}`}>
    <img src={props.src} alt="" />
  </div>
);

AbsoluteAsset.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

export default AbsoluteAsset;



// WEBPACK FOOTER //
// ./src/components/AbsoluteAsset/index.jsx